var _circle, _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FFF4DF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.61523,
    y: 14.2307,
    width: 8.07692,
    height: 5.76923,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4176 13.3683H9.72217C9.23888 13.3683 8.8457 13.7656 8.8457 14.254V19.639C8.8457 20.1274 9.23888 20.5247 9.72217 20.5247H17.4176C17.9009 20.5247 18.2941 20.1272 18.2941 19.639V14.254C18.2941 13.7656 17.9009 13.3683 17.4176 13.3683ZM17.2423 19.4619H9.89748V14.4311H17.2423V19.4619Z",
    fill: "#FEB12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6844 13.986C21.5356 13.888 21.3477 13.8725 21.185 13.9447L17.5215 15.5744L17.9453 16.5473L20.871 15.2456V18.6721L17.9413 17.397L17.5253 18.3734L21.1888 19.9676C21.2556 19.9965 21.3264 20.0109 21.3969 20.0109C21.498 20.0109 21.5988 19.9813 21.6859 19.9235C21.8337 19.8252 21.9228 19.6585 21.9228 19.4796V14.4312C21.9228 14.2515 21.8332 14.0842 21.6844 13.986Z",
    fill: "#FEB12B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0019 8.46182C9.82268 8.46182 8.86328 9.43131 8.86328 10.6229C8.86328 11.8145 9.82268 12.784 11.0019 12.784C12.1811 12.784 13.1405 11.8145 13.1405 10.6229C13.1405 9.43129 12.1811 8.46182 11.0019 8.46182ZM11.0019 11.7212C10.4025 11.7212 9.91506 11.2284 9.91506 10.6229C9.91506 10.0173 10.4027 9.52467 11.0019 9.52467C11.6012 9.52467 12.0887 10.0173 12.0887 10.6229C12.0887 11.2286 11.6012 11.7212 11.0019 11.7212Z",
    fill: "#FEB12B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8749 8.46139C14.6957 8.46139 13.7363 9.43088 13.7363 10.6225C13.7363 11.8141 14.6957 12.7836 15.8749 12.7836C17.0541 12.7836 18.0135 11.8141 18.0135 10.6225C18.0135 9.43086 17.0543 8.46139 15.8749 8.46139ZM15.8749 11.7208C15.2756 11.7208 14.7881 11.2279 14.7881 10.6225C14.7881 10.0168 15.2758 9.52424 15.8749 9.52424C16.4743 9.52424 16.9617 10.0169 16.9617 10.6225C16.9617 11.2281 16.4743 11.7208 15.8749 11.7208Z",
    fill: "#FEB12B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionIcon);
export default __webpack_public_path__ + "static/media/production-icon.a3cbba6a.svg";
export { ForwardRef as ReactComponent };